import React from "react";
import SEO from "./seo/SEO";
import Header from "./components/Header";
import Hero from "./pages/Hero";
import About from "./pages/About";
import Products from "./pages/Products";
import Benefits from "./pages/Benefits";
import Highlights from "./pages/Highlights";
import Offerings from "./pages/Offerings";
import Applications from "./pages/Applications";
import Catalogue from "./pages/Catalogue";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Gallery from "./pages/Gallary";
import NotFound from "./pages/NotFound";

export default function App() {
  const validPaths = ["/"];

  // If current URL path is NOT valid → show 404 page
  if (!validPaths.includes(window.location.pathname)) {
    return <NotFound />;
  }
  return (
    <div className="min-h-screen bg-[#0B0B0C] text-neutral-100 selection-gold antialiased">
      <SEO />
      <Header />
      <Hero />
      <Gallery/>
      <Highlights />
      <About />
      <Offerings />
      <Products />
      {/* <Benefits /> */}
      <Catalogue />
      <Contact />
      <Footer />
    </div>
  );
}
